import { CustomToggleButtonGroup } from './components'
import { CustomToggleButtonGroupProps } from './types'

export function ToggleButtonGroup(props: JSX.IntrinsicAttributes & CustomToggleButtonGroupProps) {
  return <CustomToggleButtonGroup {...props}>{props.children}</CustomToggleButtonGroup>
}
